import { useTranslation } from 'react-i18next'
import { copyTextToClipboard as copyToClipboard } from 'shared/utils'
import { useSnackbar } from 'notistack'

interface UseCopyTextToClipboardProps {
  hideSnackbar?: boolean
}

const defaultProps: UseCopyTextToClipboardProps = {
  hideSnackbar: false,
}

export const useCopyTextToClipboard = ({
  hideSnackbar,
}: UseCopyTextToClipboardProps = defaultProps) => {
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const copyTextToClipboard = (text: string) => {
    copyToClipboard(text)
    if (hideSnackbar) return
    enqueueSnackbar(t('copiedToClipboard'), { variant: 'success' })
  }

  return {
    copyTextToClipboard,
  }
}
